import React from 'react';
import Type from 'prop-types';
import { useField } from 'formik';
import InputMask from 'react-input-mask';
import { TextField } from "@mui/material";

const MaskedField = ({ disabled, mask, maskPlaceholder, ...props }) => {
  const [field, meta] = useField(props);
  const errorText = meta.error && meta.touched ? meta.error : '';

  return (
    <InputMask mask={mask} maskPlaceholder={maskPlaceholder} disabled={disabled} {...field}>
      <TextField {...props} error={!!errorText} helperText={errorText} />
    </InputMask>
  );
};

MaskedField.propTypes = {
  name: Type.string.isRequired,
  label: Type.string.isRequired,
  type: Type.string,
  mask: Type.oneOfType([
    Type.string,
    Type.arrayOf(Type.oneOfType([Type.string, Type.instanceOf(RegExp)])),
  ]).isRequired,
  maskPlaceholder: Type.string,
  disabled: Type.bool,
};

MaskedField.defaultProps = {
  type: 'text',
  maskPlaceholder: null,
  disabled: false,
};

export default MaskedField;
